type GetFormattedDeliveryMessageArg = {
  isSelectedDeviceAvailableOnline: boolean;
  isSelectedDeviceAvailableForPreorder: boolean;
  deliveryMessage?: string;
};

export const getFormattedDeliveryMessage = ({
  isSelectedDeviceAvailableOnline,
  isSelectedDeviceAvailableForPreorder,
  deliveryMessage,
}: GetFormattedDeliveryMessageArg) => {
  const deliveryEstimate = `Estimated ${
    deliveryMessage ?? '3-5 working days'
  }.`;

  if (isSelectedDeviceAvailableForPreorder) {
    return `This item is out of stock and available on pre-order. Extended delivery applies. ${deliveryEstimate}`;
  }
  if (isSelectedDeviceAvailableOnline) {
    return deliveryEstimate;
  }
  return 'This product is out of stock online.';
};
